module.exports = __webpack_public_path__ + "img/Icon_FlexibleHours.da68eb70.png";